import { endpoints, type ResponseOf } from "./endpoints";
import { apiKey, apiQuery } from "./query";

/**
 * The queries the shell itself needs on every page: the session, the organization's
 * projects (the switcher) and the setup progress (the overview card and the setup flow).
 * Page queries live in their route modules.
 */

export function sessionQuery() {
  return apiQuery(endpoints.session, {});
}

/** Invalidated whenever another query answers 401, so the root shows the Access page. */
export const sessionKey = apiKey(endpoints.session);

export type ProjectList = ResponseOf<typeof endpoints.projects>;
export type Project = ProjectList["data"][number];

export function projectsQuery(orgId: string) {
  return apiQuery(endpoints.projects, { orgId });
}

export type Organization = ResponseOf<typeof endpoints.organization>;

export function organizationQuery(orgId: string) {
  return apiQuery(endpoints.organization, { orgId });
}

export type OnboardingProgress = ResponseOf<typeof endpoints.onboarding>;

export function onboardingQuery(orgId: string) {
  return apiQuery(endpoints.onboarding, { orgId });
}
